import { Locale } from './types';

export const supportedLocales = [Locale.EN, Locale.DE];
